// src/api/measurement-defaults.ts
//
// Admin-only: which version (or Perplexity Agent preset) a NEW client's first
// read of each lane runs. The lanes and their choices come DOWN with the GET,
// so this page never carries its own copy of the catalog's allowlists.
import { apiFetch } from "./api-fetch";

export interface MeasurementDefaultChoice {
  value: string;
  label: string;
}

export interface MeasurementDefaultLane {
  lane: string;
  label: string;
  /** "preset" for Perplexity (Agent API tier), "model" for every other lane. */
  kind: "preset" | "model";
  /** What a new client's first read of this lane runs right now. */
  value: string | null;
  value_label: string;
  /** Where `value` comes from: an admin's choice, the built-in default, or
   *  the catalog's Current resolution (moves with the catalog). */
  source: "admin" | "built_in" | "catalog";
  /** What clearing the admin's choice goes back to. */
  reset_value: string | null;
  choices: MeasurementDefaultChoice[];
}

export interface MeasurementDefaultsSettings {
  lanes: MeasurementDefaultLane[];
}

export const measurementDefaultsApi = {
  get: () => apiFetch<MeasurementDefaultsSettings>("/admin/measurement-defaults"),

  /** {lane: value}, or {lane: null} to go back to the built-in/catalog value.
   *  Lanes left out are unchanged. */
  update: (lanes: Record<string, string | null>) =>
    apiFetch<MeasurementDefaultsSettings>("/admin/measurement-defaults", {
      method: "PUT",
      body: JSON.stringify({ lanes }),
    }),
};
